import Head from "next/head";
import dynamic from "next/dynamic";
const UnitsTierListPage = dynamic(
  () => import("../../../src/tier-list/UnitsTierListPage.tsx"),
  {
    ssr: false,
  },
);

export default function UnitsTierList() {
  return (
    <>
      <Head>
        <title>Units Tier List - TFT Set 18</title>
      </Head>
      <UnitsTierListPage />
    </>
  );
}
